export const  types = {
  EXPORTEXCEL:'EXPORT-TO-EXCEL',
  READ: 'READ'
};